// https://codepen.io/mikkeltschentscher/pen/oNxOzyG

var BACKSPACE_KEY = 8;
var ENTER_KEY = 13;
var TAB_KEY = 9;
var LEFT_KEY = 37;
var RIGHT_KEY = 39;
var ZERO_KEY = 48;
var NINE_KEY = 57;

function otp(elementId) {

  var inputs = document.querySelectorAll('.js-otp-input');
  var callback = null;
  var product = {
    p: null,
    i: null
  };

  function init(completeCallback) {
    callback = completeCallback;
    for (i = 0; i < inputs.length; i++) {
      registerEvents(i, inputs[i]);
    }
  }
  function setProduct(p,i) {
    product.p = p;
    product.i = i;    
  }
  function registerEvents(index, element) {
    element.addEventListener("input", function(ev) {
      onInput(index, ev);
    });
    element.addEventListener("paste", function(ev) {
      onPaste(index, ev);
    });
    element.addEventListener("keydown", function(ev) {
      onKeyDown(index, ev);
    });
  }

  function onPaste(index, ev) {
    ev.preventDefault();
    var curIndex = index;
    var clipboardData = ev.clipboardData || window.clipboardData;
    var pastedData = clipboardData.getData("Text");
    for (i = 0; i < pastedData.length; i++) {
      if (i < inputs.length) {
        if (!isDigit(pastedData[i])) break;
        inputs[curIndex].value = pastedData[i];
        curIndex++;
      }
    }
    if ( isOTPComplete() ) {
      inputs[curIndex - 1].focus();
      callback(validateOTP());
    } else {
      inputs[curIndex].focus();
    }
  }

  function onKeyDown(index, ev) {
    var key = ev.keyCode || ev.which;
    if (key == LEFT_KEY && index > 0) {
      ev.preventDefault(); // prevent cursor to move before digit in input
      inputs[index - 1].focus();
    }
    if (key == RIGHT_KEY && index + 1 < inputs.length) {
      ev.preventDefault();
      inputs[index + 1].focus();
    }
    if (key == BACKSPACE_KEY && index > 0) {
      if (inputs[index].value == "") {
        // Empty and focus previous input and current input is empty
        inputs[index - 1].value = "";
        inputs[index - 1].focus();
      } else {
        inputs[index].value = "";
      }
    }
    if (key == ENTER_KEY) {
      // force submit if enter is pressed
      ev.preventDefault();
      if (isOTPComplete()) {
        callback(validateOTP());
      }
    }
    if (key == TAB_KEY && index == inputs.length - 1) {
      // force submit if tab pressed on last input
      ev.preventDefault();
      if (isOTPComplete()) {
        callback(validateOTP());
      }
    }
  }

  function onInput(index, ev) {
    var value = ev.data || ev.target.value;
    var curIndex = index;
    for (i = 0; i < value.length; i++) {
      if (i < inputs.length) {
        if (!isDigit(value[i])) {
          inputs[curIndex].value = "";
          break;
        }
        inputs[curIndex++].value = value[i];
        if (curIndex == inputs.length) {
          if(isOTPComplete()) {
            callback(validateOTP());
          }
        } else {
          inputs[curIndex].focus();
        }
      }
    }
  }

  function validateOTP() {
    var otp = "";
    for (i = 0; i < inputs.length; i++) {
      otp += inputs[i].value;
    }
    Do.Ajax('/auth/onetime/check',{
      code:otp,
      i:product.i,
      p:product.p
    })
  }

  function isDigit(d) {
    return d >= "0" && d <= "9";
  }

  function isOTPComplete() {
    var isComplete = true;
    var i = 0;
    while (i < inputs.length && isComplete) {
      if (inputs[i].value == "") {
        isComplete = false;
      }
      i++;
    }
    $('#onetime-confirm').prop('disabled',!isComplete);
    return isComplete;
  }

  return {
    init: init,
    setProduct: setProduct,
  };
}

var OnetimeCallbacks = function(){

  var _validationError = function(r) {
    $('#onetime-message').empty().removeClass('d-none').html(r.e);
    $('#onetime-confirm').prop('disabled',true);
    $('#onetime-message #onetime-resend').off().on('click',function(){
      $('#onetime-message').empty().addClass('d-none');
      $('#onetime-confirm').prop('disabled',true);
      Do.Ajax('/auth/onetime/resend',{})
    });
  }

  var _handleSubmit = function(){
    $('#onetime-confirm').off().on('click',function(){
      $(this).prop('disabled',true);
      if(otpModule.isOTPComplete()) {
        otpModule.validateOTP();
      }
    });
  }

  var _afterResend = function(r){
    $('#onetime-message').empty().removeClass('d-none').html(r.m);
    $('#onetime-confirm').prop('disabled',true);
  }

  return {

    validationError:function(r){
      _validationError(r);
    },
    handleSubmit:function(){
      _handleSubmit();
    },
    afterResend:function(r){
      _afterResend(r);
    }
    

  }
}();
